module.exports = __webpack_public_path__ + "263fb9a83f3990ecbb8b9bf7e3d940f5.fbx";